import { createContext, useContext, useRef, useEffect } from 'react';

export const FormContext = createContext();

export const useGeckoFormContext = (name) => {
  const formData = useContext(FormContext);

  if (!formData) return null;

  const {
    values,
    errors,
    requiredErrors,
    touched,
    handleChange,
    requiredFields,
    hasTriedToSubmit,
  } = formData;
  const value = values[name];
  const error = errors[name];
  const hasTouched = touched[name];
  const requiredError = requiredErrors && requiredErrors.includes(name);
  const required = requiredFields && requiredFields.includes(name);

  return {
    value,
    handleChange,
    error,
    requiredError,
    hasTouched,
    required,
    hasTriedToSubmit,
  };
};

export const useDidUpdateEffect = (fn = () => {}, value) => {
  const didMountRef = useRef(false);

  useEffect(() => {
    if (didMountRef.current) fn();
    else didMountRef.current = true;
  }, [value]);
};
